import {
  GetPaymentStatisticsParams,
  GetPaymentStatisticsResponse,
} from '@nxsys/types/api/statistics';
import axios from '../axios';
import { endPoints } from '../endpoints';

export const getPaymentStatisticsApi = async (
  params?: GetPaymentStatisticsParams,
): Promise<GetPaymentStatisticsResponse> => {
  const response = await axios.get(endPoints.dashboard.statistics.payments, {
    params,
  });
  return response.data;
};
